<template>
    <Notifications 
        :isMobile="isMobile"
        initialTab="sent"
        :inPage="true"
        @set-current-date="$emit('set-current-date', $event)"
        :data-component-name="$options.name"
    />
</template>

<script>
    import Notifications from '@/components/notifications/Notifications'

    export default {
        name: 'Inbox',
        components: { 
            Notifications
         },
        props: {
            isMobile: {
                type: Boolean,
                default: false
            }
        },
        //},
        //data(){
        //	return {
        //	}
        //},
        //mounted(){},
        //computed: {},
        //watch: {},
        //methods: {},
    }
</script>